export default __webpack_public_path__ + "locales/nl/FilesSettings.json?hash=2cc90b0b760f40c9789c9db9c46ed145";